/** "Remove for the whole week": the person's blocks on the same line in the block's week. */
import { addDays, parseISO, startOfWeek } from "date-fns";

import { RosterAssignment } from "../../../../../services/roster-assignments-api";

type Block = Pick<RosterAssignment, "id" | "workerId" | "workstation" | "startTime">;

/** Every block of the person on the block's line that starts in its Monday-to-Sunday week, the block included. */
export function weekBlocksOf<T extends Block>(assignments: T[], block: Block): T[] {
	const monday = startOfWeek(parseISO(block.startTime), { weekStartsOn: 1 });
	const nextMonday = addDays(monday, 7);
	const line = (block.workstation ?? "").toLowerCase();
	return assignments.filter((a) => {
		if (String(a.workerId) !== String(block.workerId) || (a.workstation ?? "").toLowerCase() !== line) return false;
		const start = parseISO(a.startTime);
		return start >= monday && start < nextMonday;
	});
}
